import { PresenceTypeEnum } from '@/types/presences';

export function buildCompositeKey(type: PresenceTypeEnum, id: string): string {
  return `${type}:${id}`;
}

export function parseCompositeKey(key: string): {
  presenceType: PresenceTypeEnum;
  presenceId: string;
} {
  const idx = key.indexOf(':');
  if (idx === -1) throw new Error(`Clave compuesta inválida: "${key}"`);
  return {
    presenceType: key.slice(0, idx) as PresenceTypeEnum,
    presenceId: key.slice(idx + 1),
  };
}
